
export default {
    appMode: {
        mobile: 'MOBILE',
        pc: 'PC'
    },
    scrollThreshold: 16
}

